<template>
  <DashboardPage>
    <CompanyGroupForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import CompanyGroupForm from './components/CompanyGroupForm.vue';

const route = useRoute()
</script>